import { render, staticRenderFns } from "./WaardenRoundIndicator.vue?vue&type=template&id=c6b58cce&scoped=true&"
import script from "./WaardenRoundIndicator.vue?vue&type=script&lang=js&"
export * from "./WaardenRoundIndicator.vue?vue&type=script&lang=js&"
import style0 from "./WaardenRoundIndicator.vue?vue&type=style&index=0&id=c6b58cce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b58cce",
  null
  
)

export default component.exports